import { useContext, useState } from "react";

import { LockOutlined } from "@mui/icons-material";
import { Avatar, Button, CircularProgress, Typography } from "@mui/material";
import { toast } from "@rubi/ui";
import { matchIsValidTel } from "mui-tel-input";

import ViewOrEditPhoneField, {
  PHONE_COUNTRY_OPTIONS,
} from "@/common/MultiStateFields/ViewOrEditPhoneField";
import { AuthStateContext } from "@/contexts/AuthContext";
import styles from "@/layout/Home.module.css";
import LoginWrapper from "@/layout/LoginWrapper";

const AddPhone = () => {
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const { addPhoneNumber } = useContext(AuthStateContext);

  const handleSubmit = () => {
    setLoading(true);

    setError("");
    if (!phoneNumber) {
      setError("Please enter a phone number");
      setLoading(false);
      return;
    }

    if (
      !matchIsValidTel(phoneNumber, { onlyCountries: PHONE_COUNTRY_OPTIONS })
    ) {
      setError("Please enter a valid phone number");
      setLoading(false);
      return;
    }

    addPhoneNumber(phoneNumber.replace(/\s/g, "")).catch(() => {
      toast.error(
        "An error occurred when adding the phone number. Please try again. If the problem persists, please contact support@tryrubicon.com.",
      );
      setLoading(false);
    });
  };

  function enterPressed(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter" && !loading) {
      handleSubmit();
    }
  }
  return (
    <LoginWrapper>
      <div className={styles.paper}>
        <Avatar className={styles.avatar}>
          <LockOutlined />
        </Avatar>
        <Typography component="h1" variant="h5">
          Add Phone Number
        </Typography>
        <Typography component="p">
          This number will be used to send SMS verification codes for
          multi-factor authentication.
        </Typography>
        <div className={styles.form}>
          <ViewOrEditPhoneField
            mode="add"
            label="Phone Number"
            value={phoneNumber}
            required
            autoFocus
            disabled={loading}
            onChange={(value) => setPhoneNumber(value)}
            onKeyDown={enterPressed}
          />

          <Button
            name="Submit"
            variant="contained"
            type="submit"
            color="primary"
            size="large"
            disabled={loading}
            fullWidth
            onClick={() => {
              handleSubmit();
            }}
          >
            {loading && <CircularProgress size={25} thickness={2} />}
            {"Submit"}
          </Button>

          {error && <h3 className={styles.errorMessage}>{error}</h3>}
        </div>
      </div>
    </LoginWrapper>
  );
};

export default AddPhone;
